// export const Host = 'http://127.0.0.1:8080';
// export const Host = '';

let host = '';
if (window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1')) {
  host = 'http://127.0.0.1:8080';
}

export const Host = host;
